import { useTranslation } from 'react-i18next';

import { IconType } from '../../../constants/icons';
import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './GameTypeHelpPopup.module.css';

type GameTypeHelpPopupProps = {
  onPrimary: () => void;
  type: GameTypeHelpType;
};

export const GameTypeHelpPopup = (props: GameTypeHelpPopupProps) => {
  const { onPrimary, type } = props;

  const { t } = useTranslation();
  const info = gameTypeHelpInfo[type];

  return (
    <BasicPopupContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.popupContent}>
        <div className={styles.noticeIcon}>
          <SvgIcon
            name={info.svgIcon}
            height={80}
            width={80}
            color={'#000000'}
          />
        </div>
        <div className={styles.title}>{t(info.title)}</div>
        <div className={styles.description}>{t(info.description)}</div>
      </div>
    </BasicPopupContainer>
  );
};

export enum GameTypeHelpType {
  Assisted = 'assisted',
  Spelling = 'spelling',
  Syllable = 'syllable',
  JoyaPassageBasic = 'joyaPassageBasic',
  JoyaPassage = 'joyaPassage',
  ScriptureBasic = 'scriptureBasic',
  ScriptureStandard = 'scriptureStandard',
  FingerWritingStrokeBySpelling = 'fingerWritingStrokeBySpelling',
  FingerWritingStrokeByComponent = 'fingerWritingStrokeByComponent',
}

export const stringToGameTypeHelpType = (
  str: string | undefined | null,
): GameTypeHelpType | undefined => {
  switch (str) {
    case 'assisted':
      return GameTypeHelpType.Assisted;
    case 'spelling':
      return GameTypeHelpType.Spelling;
    case 'syllable':
      return GameTypeHelpType.Syllable;
    case 'joyaPassageBasic':
      return GameTypeHelpType.JoyaPassageBasic;
    case 'joyaPassage':
      return GameTypeHelpType.JoyaPassage;
    case 'scriptureBasic':
      return GameTypeHelpType.ScriptureBasic;
    case 'scriptureStandard':
      return GameTypeHelpType.ScriptureStandard;
    case 'fingerWritingStrokeBySpelling':
      return GameTypeHelpType.FingerWritingStrokeBySpelling;
    case 'fingerWritingStrokeByComponent':
      return GameTypeHelpType.FingerWritingStrokeByComponent;
    default:
      return undefined;
  }
};

const gameTypeHelpInfo: Record<
  GameTypeHelpType,
  { title: string; description: string; icon: IconType; svgIcon: SVGIconType }
> = {
  [GameTypeHelpType.Assisted]: {
    title: 'Interactive Learning',
    description: 'Guide you to learn step by step.',
    icon: IconType.TutorGame,
    svgIcon: SVGIconType.TutorGames,
  },
  [GameTypeHelpType.Spelling]: {
    title: 'Spelling Memory Practice · Standard',
    description: 'Learn word by spelling.', // TODO
    icon: IconType.GameTypeSpellingBig,
    svgIcon: SVGIconType.SpellingJoy,
  },
  [GameTypeHelpType.Syllable]: {
    title: 'Spelling Memory Practice · Syllables & Color Letters',
    description: 'Learn components of the word before spelling.',
    icon: IconType.GameTypeSpellSyllable,
    svgIcon: SVGIconType.GameTypeSyllable,
  },
  [GameTypeHelpType.JoyaPassageBasic]: {
    title: 'Knowledge Memory Practice · Basic',
    description: 'Memorize Text Content.', // TODO
    icon: IconType.GameTypeJoyAPassage,
    svgIcon: SVGIconType.QuickMemoryJoy,
  },
  [GameTypeHelpType.JoyaPassage]: {
    title: 'Knowledge Memory Practice · Standard',
    description: 'Memorize Text Content.', // TODO
    icon: IconType.GameTypeJoyAPassage,
    svgIcon: SVGIconType.QuickMemoryJoy,
  },
  [GameTypeHelpType.ScriptureBasic]: {
    title: 'Scripture Memory Practice · Basic',
    description: 'Memorize Text Content.', // TODO
    icon: IconType.GameTypeJoyAPassage,
    svgIcon: SVGIconType.QuickMemoryJoy,
  },
  [GameTypeHelpType.ScriptureStandard]: {
    title: 'Scripture Memory Practice · Standard',
    description: 'Memorize Text Content.', // TODO
    icon: IconType.GameTypeJoyAPassage,
    svgIcon: SVGIconType.QuickMemoryJoy,
  },
  [GameTypeHelpType.FingerWritingStrokeBySpelling]: {
    title: 'Handwriting Memory Practice · Standard',
    description: 'Type strokes of the word to get accurate memory.', // TODO
    icon: IconType.GameTypeFingerWritingStroke,
    svgIcon: SVGIconType.GameTypeFingerWritingStroke,
  },
  [GameTypeHelpType.FingerWritingStrokeByComponent]: {
    title: 'Handwriting Memory Practice · Components & Color Strokes',
    description: 'Type strokes of the word to get accurate memory.', // TODO
    icon: IconType.GameTypeFingerWritingColor,
    svgIcon: SVGIconType.GameTypeFingerWritingClickComponent,
  },
};
